import TransactionService from "../service";
import { router } from "@/router";

export const actions = {
  listTransactions({ commit, dispatch }, data) {
    dispatch("enableLoadind");

    TransactionService.list()
      .then(res => {
        dispatch("disableLoading");
        commit("setTransactions", res.data);
      })
      .catch(e => {
        dispatch("disableLoading");
        dispatch("createGlobalMessage", {
          type: "error",
          message: e.response.data.message,
          timeout: 6000
        });
      });
  },
  list_reports({ commit, dispatch }) {
    dispatch("enableLoadind");

    TransactionService.list_reports()
      .then(res => {
        dispatch("disableLoading");
        commit("set_reports", res.data);
      })
      .catch(e => {
        dispatch("disableLoading");
        dispatch("createGlobalMessage", {
          type: "error",
          message: e.response.data.message,
          timeout: 6000
        });
      });
  }
};

export default {};
